import placeholderImage from "../../resources/images/placeholder.jpg";
import { VinoDataOffer } from "../../types/vino-data-types";

// Used for loading states on product collections
export const skeletonOffer: VinoDataOffer = {
  id: undefined,
  cardImage: {
    title: undefined,
    description: undefined,
    contentType: undefined,
    fileName: undefined,
    size: 0,
    url: placeholderImage,
    width: 600,
    height: 600,
  },
  packPrice: 0,
  displayFlags: [],
  bigcommerceId: undefined,
  name: "Loading…",
  sku: { wines: [], packSize: 1, skuType: "MultiWineSKU", inventoryStatus: "AVAILABLE"  },
  channels: [],
  secret: false,
};
